module.exports = __webpack_public_path__ + "img/06.157bb4b5.png";